/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\TimeConditionRoutingSection.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the PBX Incoming Call Tools module.
----------------------------------------------------------------*/


import { Label } from '../../../components/ui/label';
import SimpleTooltip from '../../../components/ui/SimpleTooltip';
import ModuleDestinationSelect from '../../../components/ui/ModuleDestinationSelect';
import type { TimeConditionFormData } from '../formTypes';

interface TimeConditionRoutingSectionProps {
    formData: TimeConditionFormData;
    onFieldChange: <K extends keyof TimeConditionFormData>(field: K, value: TimeConditionFormData[K]) => void;
    t: (key: string) => string;
}

export function TimeConditionRoutingSection({ formData, onFieldChange, t }: TimeConditionRoutingSectionProps) {
    return (
        <div className="rounded-lg border border-border bg-card p-6">
            <div className="mb-4">
                <h3 className="text-lg font-semibold">{t('timeConditions.sections.routing')}</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-start">

                {/* Match Destination */}
                <Label>
                    <SimpleTooltip content={t('timeConditions.fields.destinationMatch.tooltip')}>
                        <span>{t('timeConditions.fields.destinationMatch.label')}</span>
                    </SimpleTooltip>
                </Label>
                <div className="col-span-3">
                    <ModuleDestinationSelect
                        moduleValue={formData.destinationMatchModule}
                        destinationValue={formData.destinationMatchValue}
                        onModuleChange={(value) => onFieldChange('destinationMatchModule', value || '')}
                        onDestinationChange={(value) => onFieldChange('destinationMatchValue', value || '')}
                        modulePlaceholder={t('timeConditions.fields.destinationMatch.modulePlaceholder')}
                        destinationPlaceholder={t('timeConditions.fields.destinationMatch.valuePlaceholder')}
                    />
                </div>

                {/* No-Match Destination */}
                <Label>
                    <SimpleTooltip content={t('timeConditions.fields.destinationNomatch.tooltip')}>
                        <span>{t('timeConditions.fields.destinationNomatch.label')}</span>
                    </SimpleTooltip>
                </Label>
                <div className="col-span-3">
                    <ModuleDestinationSelect
                        moduleValue={formData.destinationNomatchModule}
                        destinationValue={formData.destinationNomatchValue}
                        onModuleChange={(value) => onFieldChange('destinationNomatchModule', value || '')}
                        onDestinationChange={(value) => onFieldChange('destinationNomatchValue', value || '')}
                        modulePlaceholder={t('timeConditions.fields.destinationNomatch.modulePlaceholder')}
                        destinationPlaceholder={t('timeConditions.fields.destinationNomatch.valuePlaceholder')}
                    />
                </div>

            </div>
        </div>
    );
}
